import { render, staticRenderFns } from "./index.vue?vue&type=template&id=497da402"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('497da402')) {
      api.createRecord('497da402', component.options)
    } else {
      api.reload('497da402', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=497da402", function () {
      api.rerender('497da402', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DMRiseBulkNotification/index.vue"
export default component.exports